import { render, staticRenderFns } from "./lab-location-selector.vue?vue&type=template&id=627dfde7&"
import script from "./lab-location-selector.vue?vue&type=script&lang=js&"
export * from "./lab-location-selector.vue?vue&type=script&lang=js&"
import style0 from "./lab-location-selector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "lab-location-selector.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
